import React from 'react';
import Navbar from '../components/Navbar';
import './About.css';
import FooterAction from '../components/FooterAction';

const ABOUT_IMAGE = '/images/about.png'; // replace with your actual image filename

export default function About() {
  return (
    <div className="about">
      <Navbar />
      <div className="about-content">
        <div className="about-image-wrap">
          <img src={ABOUT_IMAGE} alt="2gs Like Gucci" className="about-img" />
        </div>
        <div className="about-bio">
          <p>
            2gs Like Gucci is a Harlem-born artist known for blending raw lyricism with authentic
            storytelling. He has collaborated with Jim Jones and is the creator of the Downtown All-Stars
            project, which highlights emerging talent from New York. Signed to EMPIRE Records, he is
            part of a new generation of Harlem artists bringing a contemporary sound to the borough's
            established hip-hop legacy.
          </p>
        </div>
      </div>

      <FooterAction />
    </div>
  );
}